import React from 'react';

export const SortableContext = React.createContext({
  isSortable: true,
  idParent: null,
  setParent: () => {},
  setItems: () => {}
});
